/**
 * Admin SPA runs on a different port than the Nest API in dev (see .env.development).
 */
const origin =
  // Prefer 127.0.0.1 over localhost on macOS to avoid IPv6 (::1) vs IPv4 listen mismatches.
  process.env.REACT_APP_API_URL?.replace(/\/$/, '') || 'http://127.0.0.1:3000';

export const API_ORIGIN = origin;
export const GRAPHQL_HTTP_URL =
  process.env.REACT_APP_GRAPHQL_URL || `${origin}/graphql`;
